import { useEffect } from 'react';
import { getCanonicalURL } from 'utils/seo';

export const useDynamicMetaTags = (
  title: string,
  description: string,
  shouldSetCanonicalURL: boolean,
  shouldBlockIndexing: boolean
): void => {
  useEffect(() => {
    document.title = title;
    let metaDescription = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    let robotsMeta = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    let canonicalTag = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');

    if (metaDescription) {
      metaDescription.content = description;
    } else {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      metaDescription.content = description;
      document.head.appendChild(metaDescription);
    }

    // A canonical URL is the same as the current URL, but all lowercase and without any query parameters.
    // This allows Google to understand that all URLs (example: .../jobs/123 and .../JObS/123?query=nimble) are the same page, and that the canonical URL is the one that should be indexed.
    if (shouldSetCanonicalURL) {
      const canonicalURL = getCanonicalURL();

      if (canonicalTag) {
        canonicalTag.href = canonicalURL;
      } else {
        canonicalTag = document.createElement('link');
        canonicalTag.rel = 'canonical';
        canonicalTag.href = canonicalURL;
        document.head.appendChild(canonicalTag);
      }
    }

    if (shouldBlockIndexing) {
      if (!robotsMeta) {
        robotsMeta = document.createElement('meta');
        robotsMeta.name = 'robots';
        document.head.appendChild(robotsMeta);
      }
      robotsMeta.content = 'noindex, nofollow';
    }

    return () => {
      document.title = 'Nimble';
      if (metaDescription) {
        metaDescription.remove();
      }

      if (shouldSetCanonicalURL) {
        if (canonicalTag) {
          canonicalTag.remove();
        }
      }

      if (shouldBlockIndexing) {
        if (robotsMeta) {
          robotsMeta.remove();
        }
      }
    };
  }, [title, description, shouldSetCanonicalURL, shouldBlockIndexing]);
};
